import * as React from 'react'
import { countUp } from './CountUp'

const GDStatistic = ({ className, title, stat, description }): React.ReactElement => {
  return (
    <div className={`${className} white-background`}>
      <h2>{title}</h2>
      <div className="highlighted-numbers">{countUp(stat)}</div>
      <p>({description})</p>
    </div>
  )
}

export default React.memo(GDStatistic)
